import type { DeepString } from "@/lib/i18n";

/**
 * WCard - stringi drawer'a koszyka (trigger, tytul, empty state, sumy, CTA).
 * Prices/currency formatuje `formatPrice` reuse'em kontraktu z ProductCard.
 *
 * Legacy source: `web/component/w_card/LANG/w_card_pl.lang`.
 */
export const pl = {
  triggerAriaLabel: "Twój koszyk",
  drawerTitle: "Twój koszyk",
  drawerClose: "Zamknij",
  countLabel: "Ilość",
  countDecrement: "Zmniejsz ilość",
  countIncrement: "Zwiększ ilość",
  deleteItem: "Usuń pozycję z koszyka",
  variantColorAlt: "Próbka koloru wariantu",
  priceBeforePromotion: "Cena przed promocją",
  emptyState: "Koszyk jest pusty.",
  toPay: "Do zapłaty",
  continueShopping: "Kontynuuj zakupy",
  pay: "Zamawiam",
  updateFailed: "Nie udało się zaktualizować koszyka.",
  deleteFailed: "Nie udało się usunąć pozycji z koszyka.",
  updating: "Aktualizacja koszyka…",
  /** `formatPrice(129.9, "zł")` -> "129,90 zł". Pusta waluta -> tylko liczba. */
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2).replace(".", ",");
    return currency ? `${rounded} ${currency}` : rounded;
  },
} as const;

export type WCardTranslations = DeepString<typeof pl>;
